import { favoritesManager } from '../Stores/FavoritesManager'
import { restClient } from '@/Core'

interface RemoveFromFavoritesTaskParams {
    uuid?: string | null
    onCheckFavorite?: (params: { isInFavorites: boolean; favoriteUuid: string | null }) => void

    showError?: (message?: string, description?: string) => void
    showSuccess?: (message?: string, description?: string) => void
    callBack?: () => void
}

export const RemoveFromFavoritesTask = async ({
    uuid,
    onCheckFavorite,
    showError,
    showSuccess,
    callBack,
}: RemoveFromFavoritesTaskParams = {}) => {
    if (!uuid) return

    // if (favoritesManager.isFavoritesLoading) return

    favoritesManager.setIsRemoveFromFavoritesLoading(true)

    try {
        console.log('START delete', uuid)

        await restClient.delete(`/services/user/favorites/${uuid}`)

        favoritesManager.removeFavoriteByUuid(uuid)

        onCheckFavorite?.({
            isInFavorites: false,
            favoriteUuid: null,
        })
        showSuccess?.('Успіх', 'Видалено з обраного')
        callBack?.()
    } catch (error) {
        console.warn('LoadFavoritesListTask error:', error)
        showError?.('Помилка', 'Не вдалося видалити з обраного')
    } finally {
        favoritesManager.setIsFavoritesLoading(false)
    }
}
